import React from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';
import { toast, ToastContainer } from 'react-toastify';
import get from 'lodash.get';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import { toggleTriggers, logout } from './actions';
import './App.css';
import config from './config.json';

const gaTrackingID = config.environments[process.env.REACT_APP_ENVIRONMENT].GA_TRACKING_ID;

ReactGA.initialize(gaTrackingID, { debug: false });

const App = (props) => {
  return (
    <div className="dashboard">
      <Header
        dashboard={props.label || 'Unknown'}
        dataSource={props.dataSource}
        options={props.options}
        lastUpdated={props.lastUpdated}
        updatedBy={props.updatedBy}
        user={props.user}
        version={process.env.REACT_APP_VERSION}
        onToggleTriggers={props.onToggleTriggers}
        triggersEnabled={props.triggersEnabled}
        enableAuth={props.enableAuth}
        onLogOut={() => props.onLogOut(props.firebase)}
        enablePopup={props.enablePopup}
      />
      <Dashboard
        dashboard={props.match.params.dashboardId}
        isLoading={props.isLoading}
        error={props.error}
        data={props.data}
        triggersEnabled={props.triggersEnabled}
      />
      <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} />
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const timestamp = get(props.data, 'Source.TimeStamp');
  const updatedBy = get(props.data, 'Source.UserName', 'Unknown');

  const isLoading = !isLoaded(props.data) || props.data === undefined;

  let error = props.error;

  if (props.data === null && !isLoading) {
    error = { isError: true, message: `Tried fetching data from key with value ${props.dataKey}. Check this key is present.` };
  } else if (!isLoading) {
    const missingSubKeys = props.subKeys.filter(k => props.data[k] === undefined);

    if (missingSubKeys.length > 0) {
      error = {
        isError: true, message: `Expected the following subkey(s) to be present: ${props.subKeys}
Instead found: ${Object.keys(props.data)}`
      };
    }
  }

  const user = props.email !== undefined ? props.email : (state.local.auth.user && state.local.auth.user.email);

  return {
    isLoading,
    error,
    user,
    data: props.data,
    dataSource: props.dataSource,
    options: state.local.config,
    lastUpdated: timestamp,
    updatedBy: updatedBy,
    triggersEnabled: state.local.triggersEnabled,
    enableAuth: state.local.enableAuth,
    enablePopup: state.local.enablePopup,
  }
}

const mapDispatchToProps = ({
  onToggleTriggers: () => toggleTriggers(),
  onLogOut: firebase => logout(firebase),
});

const wrappedApp = connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);

//** Watch the Firebase key in props.dataKey for changes */
const firebaseWrappedComponent = firebaseConnect((props) => {
  return (props.error.isError ? [] : [
    props.dataKey,
  ])
})(wrappedApp);

//** Map the data in Firebase key to data */
const firebaseApp = connect(
  (state, props) => {
    const dashboardConfig = config.dashboards[props.match.params.dashboardId];

    if (dashboardConfig) {
      const dataKey = dashboardConfig.source;
      const subKeys = dashboardConfig.keys;
      const label = dashboardConfig.label;

      return {
        dataKey,
        subKeys,
        label,
        dataSource: dataKey,
        data: state.firebase.data[dataKey],
        error: { isError: false },
        email: state.firebase.auth.email,
      }
    } else {
      return {
        error: { isError: true, message: `Invalid dashboard id: ${props.match.params.dashboardId}`, databaseUrl: config.environments[process.env.REACT_APP_ENVIRONMENT].FIREBASE_DATABASE_URL },
      }
    }
  }
)(firebaseWrappedComponent);

const fileApp = connect(
  (state, props) => {
    const dashboardConfig = config.dashboards[props.match.params.dashboardId];

    const dataKey = dashboardConfig.source;
    const subKeys = dashboardConfig.keys;
    const label = dashboardConfig.label;

    if (state.local.data[dataKey] === undefined && !state.local.isLoading) {
      return {
        data: undefined,
        error: { isError: true, message: 'Could not find data in file', databaseUrl: 'data.json' },
      }
    }

    return {
      isLoading: state.local.isLoading,
      dataKey,
      subKeys,
      label,
      data: state.local.data[dataKey],
      error: { isError: false },
    }
  }
)(wrappedApp);

export default config.data === 'file' ? fileApp : firebaseApp;



// WEBPACK FOOTER //
// ./src/App.js